var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 202,
    viewBox: "0 0 164 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8959 44.994C65.3604 52.0472 64.9519 52.8649 64.9519 52.8649L63.6244 77.9087C63.6244 77.9087 56.6804 63.8024 49.6343 65.2335C42.5882 66.6645 44.6305 103.872 44.6305 103.872C44.6305 103.872 45.039 103.259 46.775 103.259C48.511 103.259 53.1063 102.135 53.1063 102.135C53.1063 102.135 60.3566 105.201 60.663 105.712C60.9693 106.223 77.8188 107.041 77.8188 107.041L81.8013 77.8064C81.8013 77.8064 84.5585 96.4104 84.967 96.9215C85.2733 97.4326 80.5759 98.9659 78.5336 99.5792C76.4912 100.192 88.439 118.49 88.9496 118.796C89.4602 119.103 123.057 102.544 123.057 102.544L116.623 79.0331L107.024 62.678L71.8959 44.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7852 71.9799C90.891 82.4063 94.6694 107.45 94.6694 107.45L100.49 106.734L87.8275 66.5623L85.7852 71.9799Z",
    fill: "url(#paint0_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.464 104.792L114.58 81.3841C114.58 81.3841 117.235 80.1575 117.133 79.953C117.031 79.7486 111.312 68.1978 111.312 68.1978L103.347 59.1003L94.0541 54.7048L92.0117 59.8158C93.3392 60.7358 111.414 84.4507 113.865 90.6861C116.316 96.9214 115.09 105.61 115.09 105.61L123.464 104.792ZM104.674 70.3444L100.385 63.4957C108.044 66.9712 111.21 76.682 111.21 76.682L104.674 70.3444Z",
    fill: "url(#paint1_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1847 72.3888C60.252 80.1574 60.252 87.6194 60.252 87.6194L57.1885 103.872C57.1885 103.872 58.0054 106.428 58.2096 106.428C58.4139 106.428 63.3155 86.5973 63.3155 86.5973L68.3193 66.9711C68.3193 66.9711 66.2769 51.9449 70.4638 48.5716C74.7527 45.1984 72.9146 49.9005 72.9146 49.9005L75.4675 57.2603C75.4675 57.2603 79.1438 54.2959 79.0416 53.9893C78.9395 53.6826 70.5659 45.0962 70.5659 45.0962L66.8896 48.6739L62.6007 69.1177L60.8647 74.2287L51.9805 66.1534L52.1847 72.3888Z",
    fill: "url(#paint2_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6717 82.5085C52.6967 85.4729 53.2073 88.2328 53.2073 88.2328C53.2073 88.2328 54.0242 99.6814 51.0628 100.09C41.8722 101.419 42.1785 103.361 42.6891 103.055C43.1997 102.85 56.2708 100.806 56.2708 100.806L55.3517 83.224L49.3268 76.9886L46.6717 82.5085Z",
    fill: "url(#paint3_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.162 101.521C126.324 86.1884 100.795 46.9362 81.4943 42.0297C70.9762 39.372 66.0746 48.1628 63.5216 56.7493C61.4793 63.8024 61.0708 70.5489 60.4581 70.4466C60.1517 70.3444 59.4369 69.7311 58.4157 68.9134C54.8416 65.8468 47.5913 59.7136 44.1193 66.2556C39.7282 74.5354 39.9324 106.326 38.707 106.53C39.4219 106.632 50.1442 116.65 62.1941 117.468C71.0783 118.183 81.6986 118.796 91.9103 118.899C101.714 119.001 110.598 116.65 117.133 113.277C120.81 111.437 123.669 109.29 125.507 107.246C127.447 105.201 128.366 103.259 128.162 101.521ZM53.3099 100.499C51.3696 101.828 47.4892 102.237 46.8764 101.93L47.7955 80.2597C47.7955 80.2597 51.3696 79.7486 53.7183 83.4285C56.1692 87.1084 55.2501 99.1703 53.3099 100.499ZM65.2576 66.9712C63.9301 65.7446 64.3386 50.8205 69.8529 47.4473L70.4656 48.9806C70.5677 48.9806 66.5852 68.1978 65.2576 66.9712ZM103.654 61.9624C104.981 62.5758 106.717 63.7002 108.453 65.7446C112.232 70.4466 115.193 79.3397 115.193 79.3397C115.193 79.3397 112.742 77.1931 109.985 74.4332C107.739 72.1844 105.186 69.4244 103.756 67.1756L100.897 61.2469C100.795 61.2469 101.918 61.2469 103.654 61.9624ZM97.9353 104.895C97.2205 105.815 84.3536 106.428 82.4134 104.792C82.4134 104.792 80.9837 93.0371 81.188 88.8461C81.3922 84.6551 88.2341 73.9221 88.2341 73.9221C88.2341 73.9221 98.6501 103.975 97.9353 104.895ZM118.972 103.872C118.052 103.464 106.207 106.019 102.735 105.406C102.326 105.303 102.122 105.201 101.918 105.099C100.284 103.668 93.4421 73.7177 92.7273 70.2422C92.1146 66.6645 95.7908 58.487 95.7908 58.487C95.7908 58.487 106.513 73.6154 112.742 82.8152C114.989 86.0862 116.623 88.6417 117.031 89.3572C118.359 92.1171 119.993 104.383 118.972 103.872Z",
    fill: "url(#paint4_radial_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1668 107.246C85.8854 112.868 95.7908 116.956 100.795 117.468C90.6849 117.365 66.9936 117.774 58.1094 117.161C60.4581 114.503 71.8953 96.717 65.7682 80.5663C64.2364 76.4776 62.2962 73.0021 60.0496 69.9355C61.0708 70.8555 61.1729 71.0599 61.4793 71.0599C61.9898 71.1622 62.3983 64.4157 64.5428 57.3625C63.2153 74.2287 70.0571 97.2281 80.1668 107.246Z",
    fill: "url(#paint5_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7908 69.9355C71.8967 83.7352 93.1372 65.949 89.2567 54.6026C85.4784 43.4607 80.7809 43.0518 77.8195 43.0518C65.1569 42.8474 63.2167 60.1225 66.7908 69.9355Z",
    fill: "url(#paint6_linear_911_1573)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4681 41.9274C98.2427 41.8252 96.3025 39.6786 94.4644 36.8165C91.8093 32.7277 89.3585 27.5145 89.5627 25.9812C89.9712 23.4257 98.7533 15.2482 101.51 15.2482C101.613 15.2482 101.715 15.2482 101.919 15.3504C102.327 15.657 102.736 16.4748 103.042 17.7014C103.451 19.1325 103.757 20.9725 103.859 23.1191C104.574 30.5811 103.757 40.4963 99.4681 41.9274Z",
    fill: "url(#paint7_radial_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.656 52.2515C102.533 52.0471 101.716 50.2072 101.409 48.4694C101.205 47.1406 101.307 45.9139 102.022 45.5051C102.226 45.3006 102.533 45.0962 102.839 44.8917C104.371 43.7673 106.617 42.234 108.251 45.4028C108.864 46.6295 105.596 52.6604 103.656 52.2515Z",
    fill: "url(#paint8_radial_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.756 46.2206C103.654 46.3228 103.041 47.1406 102.531 46.7317C102.428 46.4251 102.531 46.1184 102.633 45.914C102.735 45.914 102.735 45.8117 102.837 45.8117C103.552 45.4029 103.858 46.1184 103.756 46.2206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7063 26.9012C94.1571 28.5367 95.0762 26.1857 95.0762 25.6746C95.0762 25.0613 91.4 25.4701 91.5021 25.879C91.6042 26.2879 91.7063 26.9012 91.7063 26.9012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.987 37.9409C108.965 37.6343 110.395 35.0788 111.518 35.7943C112.642 36.6121 111.62 38.5542 109.987 37.9409Z",
    fill: "url(#paint9_radial_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3654 40.7008C98.14 40.5986 96.1998 38.452 94.3616 35.5899C94.5659 35.5899 93.1362 29.0478 96.7103 26.9012C100.284 24.7546 104.165 24.448 103.042 17.8037C103.45 19.2348 103.756 21.0747 103.859 23.2213C104.369 30.3767 103.45 39.2698 99.3654 40.7008Z",
    fill: "url(#paint10_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4531 46.6295C79.4531 47.5495 78.2277 53.376 73.9388 52.7627C72.7134 51.1272 71.8964 49.2872 72.5091 48.1628C72.7134 47.754 72.9176 47.2429 73.224 46.7318C75.879 42.9496 79.4531 45.6073 79.4531 46.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7246 60.838C87.7246 61.1447 87.3161 62.9846 85.9886 62.7802C85.5801 62.2691 85.3759 61.6558 85.5801 61.3491C85.6822 61.2469 85.6822 61.0424 85.7844 60.9402C86.6013 59.7136 87.7246 60.5313 87.7246 60.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5064 75.7621C48.1017 82.6108 57.7007 72.5932 55.2499 68.7089C52.7991 64.8246 48.408 63.9046 46.5699 64.7224C43.9148 65.949 42.0767 73.5132 43.5064 75.7621Z",
    fill: "url(#paint11_linear_911_1573)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1015 66.2556C48.2037 66.5623 48.1015 68.6067 46.6719 69.7311C46.1613 69.6288 45.8549 69.22 45.9571 68.7089C45.9571 68.5044 46.0592 68.3 46.0592 68.0956C46.774 66.1534 47.9994 65.949 48.1015 66.2556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5508 72.2866C45.5508 72.3888 45.755 73.1044 45.2444 73.3088C45.0402 73.2066 44.8359 73.1044 44.8359 72.8999C44.8359 72.7977 44.8359 72.7977 44.8359 72.6955C44.9381 72.0822 45.5508 72.1844 45.5508 72.2866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9743 105.61C41.9743 105.61 51.8797 113.685 56.7813 113.685C61.683 113.685 68.3206 94.5703 66.891 87.7216C65.3592 80.7707 63.0105 78.4197 63.0105 78.4197C63.0105 78.4197 67.2994 88.335 61.4787 92.8326C55.658 97.3303 46.1611 91.5038 43.506 93.957C40.851 96.3081 41.9743 105.61 41.9743 105.61Z",
    fill: "url(#paint12_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.04 103.055C126.938 104.588 126.529 106.019 125.712 107.246C123.976 110.006 120.811 111.948 117.339 113.277C109.884 116.241 100.898 116.65 100.898 116.65C100.898 116.65 100.489 110.721 102.838 105.508C106.31 106.121 120.402 103.872 121.219 104.281C122.138 104.792 119.381 91.5039 118.054 88.8462C117.747 88.1306 114.888 85.5751 112.641 82.2019C111.927 79.442 111.11 77.3976 109.884 74.5354C107.944 70.0378 105.697 65.6424 103.655 61.9625C100.694 56.7493 98.2427 53.0694 98.1406 52.9672C98.3449 53.2738 127.959 85.1663 127.04 103.055Z",
    fill: "url(#paint13_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.732 134.538L129.692 143.329H129.182V143.227L129.08 143.329L128.773 141.489L128.671 141.08L118.459 143.84H117.847L109.677 139.24L94.666 144.862L93.4406 142.102L86.9051 142.307L86.4966 142.205L86.1902 139.649L75.8763 139.751H75.7742L74.1404 133.721L66.89 134.947L63.5201 135.56V135.867L62.9074 141.387H63.0095L35.642 139.445L35.1314 132.085C35.1314 132.085 34.0081 139.956 33.2933 144.76L21.2434 145.885L8.27447 141.898C8.17235 141.489 8.07023 141.08 7.96811 140.671C7.96811 140.569 7.96811 140.569 7.96811 140.467C7.866 140.16 7.76388 139.751 7.76388 139.445C7.76388 139.24 7.66176 139.138 7.66176 138.934C7.55964 138.627 7.55964 138.423 7.45753 138.116C7.45753 138.014 7.45753 137.911 7.35541 137.809C7.15117 136.889 6.94694 135.969 6.7427 135.049C6.64058 134.538 6.53847 134.129 6.43635 133.618C6.43635 133.618 6.43635 133.618 6.43635 133.516C6.43635 133.414 6.43635 133.312 6.33423 133.312C6.33423 133.209 6.33423 133.107 6.23211 133.107C6.23211 133.005 6.23211 132.903 6.13 132.801C6.13 132.698 6.13 132.596 6.02788 132.494C6.02788 132.392 6.02788 132.289 5.92576 132.289C5.92576 132.187 5.82364 132.085 5.82364 131.983C5.82364 131.881 5.72153 131.778 5.72153 131.574C5.72153 131.472 5.72153 131.472 5.72153 131.369C5.72153 131.267 5.72153 131.165 5.61941 131.063C5.61941 130.961 5.61941 130.961 5.61941 130.858C5.51729 130.552 5.51729 130.245 5.41517 129.938C5.41517 129.836 5.41517 129.836 5.41517 129.734C5.31305 129.325 5.21094 129.018 5.21094 128.712C5.21094 128.712 10.0105 124.521 15.6269 119.614C15.7291 119.512 15.8312 119.41 15.9333 119.41L29.8213 124.214L27.3705 109.495C30.6382 106.632 32.9869 104.588 33.2933 104.179L43.6072 108.063L65.6646 113.379L69.9535 116.548L103.448 116.854L101.304 111.539L123.259 104.69L135.513 95.7971L142.661 122.17L145.112 121.863L155.732 134.538Z",
    fill: "url(#paint14_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3174 103.055L33.3945 104.179L42.5851 109.597L65.868 113.481L69.9527 117.468L110.289 120.33L103.651 117.059L70.4632 116.241L66.8891 112.152L39.3174 103.055Z",
    fill: "url(#paint15_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.234 114.401L101.508 111.641L123.463 104.792L128.161 101.521L126.731 95.2859L135.717 96.0014L137.657 105.508L117.234 114.401Z",
    fill: "url(#paint16_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.29 120.33L109.677 139.138L94.6656 144.76L93.4402 142L86.4962 142.205L86.1898 139.649L75.8759 139.751H75.7738L74.1399 133.72L70.0552 117.774V117.672L69.9531 117.468L104.979 119.921L110.29 120.33Z",
    fill: "url(#paint17_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.731 134.538L129.691 143.227H129.18L129.078 143.125V143.227L128.67 141.387L128.568 140.978L118.458 143.738H117.845L109.676 139.138L115.803 134.538L116.722 114.401L137.656 106.223L135.716 96.0015L142.864 122.374L145.315 121.965L155.731 134.538Z",
    fill: "url(#paint18_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8757 139.751H75.7736L74.1397 133.72L66.8894 134.947L63.5195 135.458L63.4174 135.765L62.8047 141.285L65.8682 113.481L69.9529 117.468L70.055 117.672V117.774L75.8757 139.751Z",
    fill: "url(#paint19_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.316 121.965L137.453 129.427L126.118 130.449L142.763 122.272L135.615 95.8993L137.555 106.121L116.621 114.299L101.406 111.539L103.55 116.854L109.575 120.023L104.878 119.716L70.362 117.876L65.7667 113.277L42.586 109.597L34.3145 130.756L19.7116 136.174L5.21094 128.814C5.31306 129.121 5.31305 129.427 5.41517 129.836C5.41517 129.836 5.41517 129.938 5.41517 130.041C5.51729 130.347 5.51729 130.654 5.61941 130.961C5.61941 131.063 5.61941 131.063 5.61941 131.165C5.61941 131.267 5.61941 131.369 5.72153 131.472C5.72153 131.574 5.72153 131.574 5.72153 131.676C5.72153 131.778 5.82364 131.881 5.82364 132.085C5.82364 132.187 5.92576 132.289 5.92576 132.392C5.92576 132.494 5.92576 132.596 6.02788 132.596C6.02788 132.698 6.02788 132.8 6.13 132.903C6.13 133.005 6.13 133.107 6.23211 133.209C6.23211 133.312 6.23211 133.414 6.33423 133.414C6.33423 133.516 6.33423 133.618 6.43635 133.618C6.43635 133.618 6.43635 133.618 6.43635 133.72C6.53847 134.129 6.64058 134.64 6.7427 135.152C6.94694 136.072 7.15117 136.991 7.35541 137.911C7.35541 138.014 7.35541 138.116 7.45753 138.218C7.55964 138.525 7.55964 138.729 7.66176 139.036C7.66176 139.24 7.76388 139.343 7.76388 139.547C7.866 139.854 7.96811 140.263 7.96811 140.569C7.96811 140.671 7.96811 140.671 7.96811 140.774C8.07023 141.182 8.17235 141.591 8.27447 142L21.1413 145.885L33.1912 144.76C33.906 139.956 35.0293 132.085 35.0293 132.085L35.5399 139.445L62.9074 141.387H62.8053L63.418 135.867V135.56L66.7879 134.947L74.0382 133.72L75.6721 139.751H75.7742L86.0881 139.649L86.3945 142.205L89.8665 141.898L93.3385 142L94.5639 144.76L109.575 139.138L117.745 143.738H118.357L128.569 140.978L128.671 141.387L126.629 130.552L137.147 130.756L129.08 143.125V143.227H129.59L155.63 134.436L145.316 121.965ZM98.8528 139.956L85.067 139.649L106.614 133.823L108.962 135.049L98.8528 139.956Z",
    fill: "#0A1E37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3395 38.2981C28.612 50.5928 66.7124 90.8823 69.8398 93.4803C73.009 96.2165 77.3076 104.424 78.397 108.019C79.3963 111.566 78.2799 110.622 94.063 121.604C109.846 132.586 129.9 134.492 129.627 131.101C129.361 127.482 115.435 115.407 109.151 109.616C117.461 119.85 114.986 125.133 114.986 125.133C112.766 127.772 99.0026 131.428 77.4897 102.783C55.9768 74.1367 45.3945 33.4831 46.5067 32.9183C47.6189 32.3536 66.506 40.1265 80.109 55.6226C66.9477 37.3493 22.6896 1.65066 20.8193 3.20106C18.6725 4.83553 22.067 26.0034 25.3395 38.2981ZM41.838 33.2054C46.8317 37.7277 54.0844 58.1753 49.7611 55.8655C45.4377 53.5557 34.1636 34.7841 32.9611 30.3171C31.8004 25.9884 36.7961 28.7733 41.838 33.2054ZM29.6196 20.5352C31.2428 19.664 32.5038 20.3377 31.9258 21.4196C31.3959 22.4114 32.5711 24.5458 32.5711 24.5458C30.9667 24.7317 27.9964 21.4064 29.6196 20.5352Z",
    fill: "url(#paint20_radial_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.461 104.792L137.655 106.223L136.021 104.792L128.158 101.521L123.461 104.792Z",
    fill: "url(#paint21_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5859 109.597L56.1676 108.677L48.2024 110.414L65.8688 113.481L66.8899 112.152L70.1577 115.934L70.0556 117.672L65.8688 113.481L42.5859 109.597Z",
    fill: "url(#paint22_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3711 109.494L41.6676 111.743L42.5866 109.597L56.1683 108.677L48.2031 110.414L35.0299 132.085L33.396 144.045L34.0087 130.654L35.8469 126.156L29.8219 124.214L27.3711 109.494Z",
    fill: "url(#paint23_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7116 136.174L21.1413 145.782L8.27447 141.898L5.21094 128.814L19.7116 136.174Z",
    fill: "#0B2540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7667 135.152L63.5201 135.458L63.418 135.765L65.0519 120.33L65.7667 135.152Z",
    fill: "url(#paint24_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.08 143.125V143.227L128.672 141.387L129.08 143.125Z",
    fill: "url(#paint25_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.803 134.538L117.845 143.738L109.676 139.138L115.803 134.538Z",
    fill: "url(#paint26_linear_911_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8436 165.964L18.9883 172.638L27.731 181.39L54.1072 183.911L68.4807 174.27L55.2926 166.853L34.8436 165.964Z",
    fill: "#12355E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9146 184.505L27.1382 191.031L53.2181 195.184L68.4807 185.691V174.27L54.1072 183.911L27.731 181.39L18.9883 172.638L20.9146 184.505Z",
    fill: "#0D274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5117 159.14V171.6C38.8462 174.122 44.6253 174.715 50.5525 173.973V157.36L33.5117 159.14Z",
    fill: "#0D274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.218 172.49V160.03L50.5508 157.509V173.973L53.218 172.49Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6914 122.652L20.915 121.02H34.1031L43.1421 125.322L57.5157 122.652L80.6319 126.212L74.2601 127.25L51.4403 124.58L38.2522 126.805L27.5831 122.652H14.6914Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3959 159.14L24.7677 157.509L20.915 122.652H14.6914L18.3959 159.14Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9615 165.667L18.3945 159.14L24.7663 157.509L76.7778 164.184L69.9615 165.667Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2592 127.25L70.5547 150.092L59.293 151.427L70.5547 154.542L69.962 165.667L76.7783 164.184V153.504L68.9247 150.982L76.7783 148.906L80.631 126.211L74.2592 127.25Z",
    fill: "#0C426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6914 122.652L18.3959 159.14L70.5556 165.667V154.542L61.072 151.576L70.5556 150.092L74.2601 127.25L51.4403 124.58L38.2522 126.805L27.5831 122.652H14.6914Z",
    fill: "#0D274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5102 171.748L21.3594 174.863L27.7312 181.39L49.5137 183.466L50.551 173.973L33.5102 171.748Z",
    fill: "#0D3454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7334 181.39L27.1406 191.031L28.0297 191.179L27.7334 181.39Z",
    fill: "#12355E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1078 183.911L53.2188 195.184L54.1078 194.591V183.911Z",
    fill: "#12355E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_1573",
    x1: 92.8512,
    y1: 86.4019,
    x2: 97.197,
    y2: 148.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_911_1573",
    x1: 107.92,
    y1: 85.352,
    x2: 112.266,
    y2: 147.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF000B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_911_1573",
    x1: 66.5177,
    y1: 69.9839,
    x2: 74.7263,
    y2: 133.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_911_1573",
    x1: 48.6417,
    y1: 89.4812,
    x2: 52.9875,
    y2: 151.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_911_1573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5207 60.2495) scale(63.4555 63.5187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#2548FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#1F28FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#A587FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_911_1573",
    x1: 60.4913,
    y1: 100.407,
    x2: 82.075,
    y2: 87.7543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_911_1573",
    x1: 63.2726,
    y1: 30.4622,
    x2: 89.5399,
    y2: 86.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD408F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_911_1573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.0823 22.968) scale(21.1577 21.1787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2730FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#2555FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#311FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#87A8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_911_1573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.954 46.4983) scale(7.00977 7.01675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B27FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#3625FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#1F28FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#878CFC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_911_1573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.559 31.6512) scale(22.5338 22.5563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2756FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#3625FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    stopColor: "#1F5DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#8987FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_911_1573",
    x1: 116.436,
    y1: 46.2316,
    x2: 96.3575,
    y2: 24.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_911_1573",
    x1: 47.1308,
    y1: 67.9852,
    x2: 52.2777,
    y2: 77.7076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD40A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_911_1573",
    x1: 74.1196,
    y1: 121.959,
    x2: 55.315,
    y2: 96.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_911_1573",
    x1: 143.888,
    y1: 96.2366,
    x2: 104.642,
    y2: 86.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_911_1573",
    x1: 87.3341,
    y1: 158.73,
    x2: 84.3868,
    y2: 147.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_911_1573",
    x1: 69.3062,
    y1: 127.135,
    x2: 73.5935,
    y2: 102.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_911_1573",
    x1: 118.906,
    y1: 102.554,
    x2: 120.514,
    y2: 117.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_911_1573",
    x1: 70.0012,
    y1: 131.143,
    x2: 110.294,
    y2: 131.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_911_1573",
    x1: 109.699,
    y1: 119.863,
    x2: 155.697,
    y2: 119.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_911_1573",
    x1: 70.0528,
    y1: 143.251,
    x2: 68.726,
    y2: 138.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7237B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A1C98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_911_1573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.8451 76.0882) rotate(28.1141) scale(132.716 132.848)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000980945,
    stopColor: "#06FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255499,
    stopColor: "#10F7FD",
    stopOpacity: 0.9852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#3AD5FE",
    stopOpacity: 0.9195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    stopColor: "#5EB8FE",
    stopOpacity: 0.8501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#7CA1FE",
    stopOpacity: 0.7776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#928FFF",
    stopOpacity: 0.7009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#A382FF",
    stopOpacity: 0.6182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AC7AFF",
    stopOpacity: 0.5251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF78FF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_911_1573",
    x1: 130.56,
    y1: 106.186,
    x2: 130.56,
    y2: 101.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_911_1573",
    x1: 56.3745,
    y1: 117.651,
    x2: 56.3745,
    y2: 108.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_911_1573",
    x1: 48.9977,
    y1: 142.454,
    x2: 47.3415,
    y2: 136.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_911_1573",
    x1: 66.3364,
    y1: 136.075,
    x2: 65.6474,
    y2: 133.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C426E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_911_1573",
    x1: 129.134,
    y1: 143.347,
    x2: 129.045,
    y2: 143.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7237B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A1C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_911_1573",
    x1: 114.915,
    y1: 145.207,
    x2: 114.465,
    y2: 143.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00230226,
    stopColor: "#376FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B253E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_1573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 202,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibImg2);
export default __webpack_public_path__ + "static/media/lib_img2.4a1fda83660d783fdd6e227b5f537943.svg";
export { ForwardRef as ReactComponent };